// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1VELS","content":"GlobalSearch_content__ekSvU"};